"use client";
import Button from "@/components/Cards/Button";
import SmallVideoCard from "@/components/Cards/SmallVideoCard";
import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import MasterclassStats from "@/components/MasterclassStats";
import InfoModal from "@/components/Modal";
import PlayerInPage from "@/components/Player/PlayerInPage";
import Testimonial from "@/components/Text/Testimonial";
import Triangles from "@/components/Triangles";
import { ButtonDark } from "@/stories/Button.stories";
import { TestemonialBlackImg } from "@/stories/Testemonial.stories";
import type { Video } from "@/types";
import {
    formatDuration,
    getModuleVideosWithSub,
    shuffle,
    testimonialImg,
} from "@/utils";
import { useState } from "react";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../../public/content/testimonials.json";
import videoTestimonials from "../../../../public/content/videoTestimonials.json";
import videos from "../../../../public/content/videos.json";
import { sendGTMEvent } from "@/components/Analytics";

export default function ForschungsmethodeLayout() {
    const moduleVideosWithSub = getModuleVideosWithSub(
        videos,
        "Modul 3: Bedeutung der Energiefelder",
    );
    const [id, setId] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <div className="bg-white w-full space-y-1  lg:px-20 py-20 flex-col justify-center items-center gap-5 inline-flex">
                <div className="container w-full py-20 px-3  space-y-4 gap-6 ">
                    <div className="flex flex-col py-3  justify-start">
                        <p className="lg:text-2xl text-xl text-center lg:text-start  font-bold">
                            Erfahrungsberichte
                        </p>
                        <p className="lg:text-5xl text-xl3 text-center lg:text-start font-bold">
                            Was andere zur Fernbehandlung sagen
                        </p>
                    </div>
                    <div className="lg:block md:block hidden">
                        <SliderNoArrows
                            slidesPerView={1.5}
                            paginationColor="#000"
                            centered={false}
                            contentEl={
                                <div>
                                    {videoTestimonials.videoTestimonials.map(
                                        (testemonial) => (
                                            <SwiperSlide
                                                className="lg:pb-10 pb-2"
                                                key={testemonial.id}
                                            >
                                                <PlayerInPage
                                                    videoId={testemonial.id}
                                                    thumbnail={
                                                        testimonialImg.find(
                                                            (img) =>
                                                                img.name ===
                                                                testemonial.name,
                                                        )?.url
                                                    }
                                                />
                                            </SwiperSlide>
                                        ),
                                    )}
                                </div>
                            }
                        />
                    </div>
                    <div className="lg:hidden md:hidden flex justify-center">
                        <SliderNoArrows
                            slidesPerView={1}
                            paginationColor="#000"
                            centered={false}
                            contentEl={
                                <div>
                                    {videoTestimonials.videoTestimonials.map(
                                        (testemonial) => (
                                            <SwiperSlide
                                                className="lg:pb-10 pb-6"
                                                key={testemonial.id}
                                            >
                                                <PlayerInPage
                                                    videoId={testemonial.id}
                                                    thumbnail={
                                                        testimonialImg.find(
                                                            (img) =>
                                                                img.name ===
                                                                testemonial.name,
                                                        )?.url
                                                    }
                                                />
                                            </SwiperSlide>
                                        ),
                                    )}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-black" buttomToTop={false} />
            </div>

            <div className="bg-black flex justify-center">
                <div className="container w-full">
                    <div className="">
                        <SliderNoArrows
                            paginationColor="#FFFFFF"
                            contentEl={
                                <div className="flex justify-center items-center">
                                    {shuffle(testimonials?.testimonials)?.map(
                                        (testimonial) => {
                                            return (
                                                <SwiperSlide
                                                    key={testimonial.testimonial}
                                                >
                                                    <Testimonial
                                                        backgroundColor={
                                                            TestemonialBlackImg?.args
                                                                ?.backgroundColor
                                                        }
                                                        differentTextColor={
                                                            TestemonialBlackImg?.args
                                                                ?.differentTextColor
                                                        }
                                                        hasImage={testimonial.hasImage}
                                                        text={testimonial?.testimonial}
                                                        icon={
                                                            TestemonialBlackImg?.args
                                                                ?.icon
                                                        }
                                                        textColor={
                                                            TestemonialBlackImg?.args
                                                                ?.textColor
                                                        }
                                                        name={testimonial?.name}
                                                        hasDescription={false}
                                                        wordsInDifferentColor={[""]}
                                                        hasReadMore={true}
                                                    />
                                                </SwiperSlide>
                                            );
                                        },
                                    )}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="bg-black -mb-[0.1rem]">
                <Triangles backgroundColor="bg-blue" buttomToTop={true} />
            </div>

            <div className="bg-blue flex justify-center">
                <div className="container w-full  space-y-1 md:px-5 px-6 py-28 flex-col justify-start  gap-5 inline-flex">
                    <div className=" text-black  text-[40px] lg:text-5xl font-bold  leading-[52px] lg:leading-14">
                        Willst du mehr zur Forschung erfahren?
                    </div>
                    <div className="lg:block hidden text-black text-xl1 font-normal lg:text-justify text-center  leading-8.5">
                        Möchtest du erfahren, was mich dazu inspiriert hat, mich mit der
                        Energiefeld-Instandsetzung zu beschäftigen? Dann sind diese
                        kostenlosen Videos genau das Richtige für dich. Ich versuche
                        meine Forschungsreise auf eine verständliche Weise aufzuzeigen
                        und berichte mit Freude über die Herzstücke meiner Forschung.{" "}
                    </div>
                    <div className="lg:space-y-5 ">
                        <div className="my-5 ">
                            <MasterclassStats
                                buttonColor="bg-white"
                                module_count="5"
                                videos_count="150"
                                videos_duration="4hrs 50min"
                                buttonTextColor="text-blue"
                            />
                        </div>
                        <div className="block lg:hidden text-black text-lg font-normal text-left  leading-7 lg:leading-8.5">
                            Möchtest du erfahren, was mich dazu inspiriert hat, mich mit
                            der Energiefeld-Instandsetzung zu beschäftigen? Dann sind
                            diese kostenlosen Videos genau das Richtige für dich. Ich
                            versuche meine Forschungsreise auf eine verständliche Weise
                            aufzuzeigen und berichte mit Freude über die Herzstücke
                            meiner Forschung.{" "}
                        </div>
                        <InfoModal
                            onClose={() => setOpenModal(false)}
                            opened={openModal}
                            size="full"
                            paddings="lg:px-5 lg:pb-7 px-0"
                            fullScreen={false}
                        >
                            <PlayerInPage videoId={id} thumbnail={thumbnail} />
                        </InfoModal>
                        <p className="lg:text-xl1 text-lg font-normal leading-8.5 md:leading-7  ">
                            Schau dir 8 Videos aus der Masterclass an. Lust auf mehr?
                            Dann klicke unten auf den Button und tauche tiefer in die
                            Masterclass ein.
                        </p>
                        <div className="lg:grid md:grid md:grid-cols-3 text-center gap-6 grid-cols-4">
                            {moduleVideosWithSub?.slice(0, 8).map((video: Video) => {
                                return (
                                    <div key={video.id}>
                                        <button
                                            type="button"
                                            className="curor-pointer text-left"
                                            onClick={() => {
                                                setId(video.id);
                                                setThumbnail(video.thumbnail);
                                                setOpenModal(true);
                                            }}
                                        >
                                            <SmallVideoCard
                                                img={video.thumbnail}
                                                duration={formatDuration(video.duration)}
                                                free={true}
                                                title={video.title}
                                            />
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="flex justify-center">
                        <Button
                            text="jetzt ansehen"
                            backgroundColor="bg-black"
                            border={ButtonDark.args?.border}
                            hasIcon={ButtonDark.args?.hasIcon}
                            rounded={ButtonDark.args?.rounded}
                            textColor={ButtonDark.args?.textColor}
                            size={ButtonDark.args?.size}
                            as="a"
                            href="/de/masterclass#masterclassSection"
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title:
                                        "Willst du mehr zur Forschung erfahren?",
                                    section_index: "7",
                                    cta_text: "jetzt ansehen",
                                    cta_link: `${process.env.NEXT_PUBLIC_URL}/de/masterclass#masterclassSection`,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-blue">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
        </>
    );
}
